import PropTypes from 'prop-types';
import React from 'react';
import Dropzone from 'react-dropzone';
import Modal from 'react-bootstrap/lib/Modal';

import { acceptImagesExtensions, acceptImageTypes, maxFileSize } from 'shared/constants';
import { stringifyError, validateFile } from 'shared/functions';
import ModalAlert from 'shared/ui/Modal/ModalAlert';

import ImageCropper from '../ImageCropper/ImageCropper';
import SpinnerSmall from '../Spinner/SpinnerSmall';

class ModalImageCropper extends React.Component<any> {
  modalAlert: ModalAlert;
  promise: Promise<unknown>;
  resolve: (value: unknown) => void;
  reject: (reason?: any) => void;
  static propTypes: { aspectRatio: PropTypes.Requireable<number> };
  state = {
    show: false,
    dataUrl: '',
    filename: '',
    imageSaverPromise: null,
  };

  onDropFile = (files) => {
    if (!files.length) {
      return;
    }
    const file = files[0];

    const resultValidate = validateFile(file, {
      maxFileSize,
      acceptTypes: acceptImageTypes,
    });

    if (resultValidate) {
      this.modalAlert.open(`${file.name} - ${resultValidate}`, 'The following files can not be uploaded:');
      return;
    }
    this.setState({
      file,
      progress: 0,
      error: '',
      opening: true,
    });
    const reader = new FileReader();

    reader.readAsDataURL(file);

    reader.onload = (evt) => {
      // @ts-expect-error
      if (this.unmounted) {
        return;
      }
      this.setState({
        opening: false,
        src: evt.target.result,
        filename: file.name,
      });
    };
  };

  ok = (evt) => {
    const { dataUrl, imageSaverPromise, filename } = this.state;

    if (!dataUrl) {
      this.setState({
        error: translate('Please upload and crop an image!'),
      });
      return;
    }

    const [, data] = dataUrl.split(',');

    if (data.length > maxFileSize) {
      this.setState({
        error: `${translate('File')} ${filename} ${translate('is too large')} (10 Mb max)`,
      });
      return;
    }

    evt.preventDefault();
    if (imageSaverPromise) {
      this.setState({
        uploading: true,
        error: '',
      });
      return imageSaverPromise(dataUrl).then(
        () => {
          // @ts-expect-error
          if (this.unmounted) {
            return;
          }
          this.setState({
            uploading: false,
            show: false,
          });
          // @ts-expect-error
          this.resolve();
        },
        (err) => {
          // @ts-expect-error
          if (this.unmounted) {
            return;
          }

          this.setState({
            uploading: false,
            error: stringifyError(err),
          });
        },
      );
    }
    this.setState({ show: false });
    // @ts-expect-error
    return this.resolve(dataUrl, filename);
  };

  cancel = () => {
    this.setState({ show: false });
  };

  open(src, imageSaverPromise) {
    this.setState({
      dataUrl: null,
      show: true,
      imageSaverPromise,
      src,
      error: '',
      uploading: false,
    });
    if (!src) {
      // @ts-expect-error
      setTimeout(() => this.dropzone.open(acceptImagesExtensions));
    }
    this.promise = new Promise((resolve, reject) => {
      this.resolve = resolve;
      this.reject = reject;
    });
    return this.promise;
  }

  crop = (dataUrl) => {
    this.setState({
      dataUrl,
    });
  };

  render() {
    const { aspectRatio } = this.props;
    const { dataUrl, show, src, uploading, opening, error } = this.state as any;

    if (!show) {
      return null;
    }

    return (
      <div onClick={(evt) => evt.stopPropagation()}>
        <ModalAlert ref={(ref) => (this.modalAlert = ref)} />
        <Modal show={show} onHide={this.cancel} backdrop="static" bsSize="large">
          <Modal.Header closeButton>
            <Modal.Title>{translate('Upload and/or edit image')}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {error && <div className="text-danger">{error}</div>}
            <Dropzone
              onDrop={this.onDropFile}
              // @ts-expect-error
              ref={(ref) => (this.dropzone = ref)}
              multiple={false}
              accept={acceptImagesExtensions}
              style={{ display: 'none' }}
            />
            {!src && <h3 className="text-center intro">{translate('Click "Upload" to proceed with image')}</h3>}
            <div className="row">
              {opening && SpinnerSmall}

              {!!src && (
                <div className="col-xs-9">
                  <ImageCropper
                    src={src}
                    // @ts-expect-error
                    style={{ height: 400, width: '100%' }}
                    aspectRatio={aspectRatio || 1}
                    crossOrigin="anonymous"
                    checkCrossOrigin
                    checkOrientation
                    crop={this.crop}
                  />
                </div>
              )}

              {!!dataUrl && (
                <div className="text-center col-xs-3">
                  <img
                    src={dataUrl}
                    alt={translate('Crop result')}
                    style={{
                      border: '1px solid #DEE7EB',
                      maxHeight: '100%',
                      maxWidth: '100%',
                    }}
                  />
                </div>
              )}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button
              type="button"
              disabled={opening}
              // @ts-expect-error
              onClick={() => this.dropzone.open(acceptImagesExtensions)}
              className="btn btn-primary btn-sm pull-left"
            >
              {translate('Upload')}
            </button>
            <button type="submit" onClick={this.ok} disabled={uploading} className="btn btn-success btn-sm">
              {uploading && SpinnerSmall} {translate('Save')}
            </button>
            <button type="button" disabled={uploading} onClick={this.cancel} className="btn btn-default btn-sm">
              {translate('Cancel')}
            </button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

ModalImageCropper.propTypes = {
  aspectRatio: PropTypes.number,
};

// eslint-disable-next-line import/no-default-export
export default ModalImageCropper;
